import { amplitudeEvent } from 'lib/amplitude'

export const trackScheduleCalendarViewChanged = (previousView, nextView) => {
  if (!nextView || previousView === nextView) return

  amplitudeEvent('schedule-calendar-view-changed', {
    previous_view: previousView,
    next_view: nextView,
  })
}

export const trackScheduleMonthDaySelected = day => {
  amplitudeEvent('schedule-month-day-selected', {
    selected_date: day.toISODate(),
  })
}

export const trackScheduleAddToCalendarOpened = ({
  calendarView,
  day,
  hour,
}) => {
  amplitudeEvent('schedule-add-to-calendar-opened', {
    calendar_view: calendarView,
    selected_date: day?.toISODate() ?? null,
    selected_hour: hour ?? null,
  })
}

export const trackScheduleBookingsOnlyFilterChanged = enabled => {
  amplitudeEvent('schedule-bookings-only-filter-changed', {
    enabled,
  })
}
